export const getTotalDiffSeconds = (durationNum: number, scTimeList: number[]) => {
  if (!scTimeList || scTimeList.length === 0) return `0秒`;
  // 1. 拆分为区间
  const intervals: [number, number][] = [];
  for (let i = 0; i < scTimeList.length - 1; i += 2) {
    const start = scTimeList[i];
    const end = scTimeList[i + 1];
    if (end > start) intervals.push([start, end]);
  }
  // 2. 按start排序
  intervals.sort((a, b) => a[0] - b[0]);
  // 3. 合并重叠区间
  const merged: [number, number][] = [];
  for (const [start, end] of intervals) {
    if (!merged.length || merged[merged.length - 1][1] < start) {
      merged.push([start, end]);
    } else {
      merged[merged.length - 1][1] = Math.max(merged[merged.length - 1][1], end);
    }
  }
  // 4. 统计合并后区间总时长
  let totalIncluded = 0;
  for (const [start, end] of merged) {
    totalIncluded += end - start;
  }
  // 5. 计算跳过时长
  let totalDiffSeconds = Math.floor(durationNum) - totalIncluded;
  if (totalDiffSeconds < 0) totalDiffSeconds = 0;
  const minute = Math.floor(totalDiffSeconds / 60);
  const second = Math.floor(totalDiffSeconds % 60);
  return minute > 0 ? `${minute}分${second}秒` : `${second}秒`;
};